import { PostOperation } from '@/api/rest/base/operations';
import BaseApi from './base/BaseApi';

export default class TaskApi extends BaseApi {
  static entityName = 'invitations';

  send(project = null, withPreloader = false) {
    const operation = new PostOperation('/api/invitations/send', { project });
    return this.execute(operation, withPreloader);
  }
}
